var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgPatternAbout1MobileNav1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 200",
    style: {
      enableBackground: "new 0 0 100 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2C6269;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#F67E7E;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#79C8C7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,100H0V0h100V100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100,0c55.2,0,100,44.8,100,100s-44.8,100-100,100S0,155.2,0,100S44.8,0,100,0z M100,67c-18.2,0-33,14.8-33,33 s14.8,33,33,33s33-14.8,33-33S118.2,67,100,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100,40v4H0v-4H100z M100,32v4H0v-4H100z M100,24v4H0v-4H100z M100,16v4H0v-4H100z M100,8v4H0V8H100z M100,0v4 H0V0H100z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternAbout1MobileNav1);
export default __webpack_public_path__ + "static/media/bg-pattern-about-1-mobile-nav-1.e0085d6b52cf421a2bbc6190028a513a.svg";
export { ForwardRef as ReactComponent };